"use client";

import { type ServiceContent } from "../data/types";
import { ServiceContentComponent } from "../components/ServiceContent";
import { usePathname } from "next/navigation";

interface DescriptionSecondProps {
  title: string;
  content: ServiceContent[];
}

export const DescriptionSecond = ({
  title,
  content,
}: DescriptionSecondProps) => {
  const pathname = usePathname();
  const isColorationVegetale = pathname === "/prestations/coloration-vegetale";

  return (
    <section className="w-full bg-primary py-20">
      <div className="mx-auto flex max-w-[1920px] flex-col px-4 ph:px-24 md:px-48 lg:px-72 xl:px-96">
        <div className="mb-16">
          <h2 className="font-cormorant text-4xl text-secondary ph:text-5xl sm:text-6xl lg:text-7xl">
            {title.split(" : ")[0]}
          </h2>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            {isColorationVegetale ? (
              <span className="inline-flex rounded-full border border-secondary/20 px-4 py-1.5 text-sm text-secondary/80">
                Ville d&apos;Avray (92410)
              </span>
            ) : (
              <>
                <span className="inline-flex rounded-full border border-secondary/20 px-4 py-1.5 text-sm text-secondary/80">
                  Villejuif (94800)
                </span>
                <span className="inline-flex rounded-full border border-secondary/20 px-4 py-1.5 text-sm text-secondary/80">
                  Ville d&apos;Avray (92410)
                </span>
              </>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-8 text-secondary">
          {content.map((item, index) => (
            <ServiceContentComponent key={index} content={item} />
          ))}
        </div>
      </div>
    </section>
  );
};
